const applyDateMask = (input: string, mask: string): string => {
  const digitsOnly = input.replace(/\D/g, ''); // Remove non-digit characters
  const formattedDate = mask.split('');

  let digitIndex = 0;
  for (let i = 0; i < formattedDate.length; i += 1) {
    if (formattedDate[i] === '_' && digitIndex < digitsOnly.length) {
      formattedDate[i] = digitsOnly[digitIndex];
      digitIndex += 1;
    }
  }

  return formattedDate.join('');
};

export const determineCursorPosition = (maskedDate: string): number => {
  // Find the position of the first placeholder ('_')
  let cursorPosition = maskedDate.indexOf('_');

  // If there's no placeholder, place the cursor at the end
  if (cursorPosition === -1) {
    return maskedDate.length;
  }

  // Move the cursor backwards until it's after a valid digit, not before a non-digit character
  while (cursorPosition > 0 && /\D/.test(maskedDate[cursorPosition - 1])) {
    cursorPosition -= 1;
  }

  return cursorPosition;
};

export default (input: string, mask: string): { maskedDate: string; cursorPosition: number } => {
  const maskedDate = applyDateMask(input, mask);
  const cursorPosition = determineCursorPosition(maskedDate);

  return {
    maskedDate,
    cursorPosition,
  };
};
